<template>
  <div>
    <router-view></router-view>
    <BottomSheet></BottomSheet>
  </div>
</template>

<script>
import List from '../accounts/List'
import Editor from '../accounts/Editor'
import BottomSheet from '../BottomSheet'
export default {
  components: {
    BottomSheet
  },
  routes: [
    {
      path: '',
      redirect: '/settings/accounts/list'
    },
    {
      path: "new",
      name: "New account",
      components: {
        default: List,
        bottomEditor: Editor
      },
      props: {
        default: false,
        bottomEditor: true
      },
      meta: {
        edit: "Edit account"
      }
    },
    {
      path: "edit/:id",
      name: "Edit account",
      components: {
        default: List,
        bottomEditor: Editor
      },
      props: {
        default: false,
        bottomEditor: true
      }
    },
    {
      path: "list",
      name: "Account list",
      component: List
    }
  ],
}
</script>
